const technologyParent = document.getElementById("all_technologies");
const techSearchInput = document.getElementById("default_search");
const techSuggestion = document.getElementById("suggestionsTech");
const selectTechnologyParent = document.getElementById("select_technologies");

/* Js Technology toggle start */
const toggleButton = document.getElementById("Tech_Toggle_Btn");
const allTechnology = document.getElementById("all_technologies");

const ScrollElement = document.getElementById("default_search");
const ErorDiv = document.getElementById("Technology_Error");
const Search_empty = document.getElementById("Empty_case");

let addIcon = "https://cdn.quokkalabs.com/ql-images/add_technology.png";
let removeIcon = "https://cdn.quokkalabs.com/ql-images/remove_technology.png";

toggleButton.addEventListener("click", function () {
  let expandImg = document.getElementById("tech_expand_icon");

  if (allTechnology.classList.contains("hidden")) {
    allTechnology.classList.remove("hidden");
    allTechnology.classList.add("flex");

    expandImg.setAttribute(
      "src",
      "https://cdn.quokkalabs.com/ql-images/explore_close_icon.png",
    );

    setTimeout(() => {
      allTechnology.style.opacity = 1;
      allTechnology.style.height = "auto";
    }, 10);
  } else {
    allTechnology.style.opacity = 0;
    allTechnology.style.height = 0;
    expandImg.setAttribute(
      "src",
      "https://cdn.quokkalabs.com/ql-images/explore_open_icon.png",
    );

    setTimeout(() => {
      allTechnology.classList.add("hidden");
      allTechnology.classList.remove("flex");
    }, 10);
  }
});

/* Js Technology toggle finish */

const response_loader = document.querySelector("#response_loading_popup");

function displayLoading() {
  if (response_loader) {
    response_loader.classList.remove("hidden");
    response_loader.classList.add("block");
  }
  const submitBtn = document.getElementById("form-button");
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
  }
}

function hideLoading() {
  if (response_loader) {
    response_loader.classList.add("hidden");
    response_loader.classList.remove("block");
  }
  const submitBtn = document.getElementById("form-button");
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = "Submit";
  }
}

const fetchedData = async function () {
  await fetch(`${process.env.APIURL}/blog/api/technologies`)
    .then((response) => response.json())
    .then(async (parsedData) => {
      let techData = parsedData.data;

      const techlist = techData
        .map(({ id, name, image_url }) => {
          const TechnologyId = id;
          const TechnologyName = name;
          const ImgUrl = image_url;
          return `<div class="technology_btn inline-flex items-center border border-gray-500 bg-white bg-transparent Gilroy-medium cursor-pointer rounded p-3 mr-2 mb-2" data-name="${TechnologyName}" id="item_${TechnologyId}">
             <img src="${ImgUrl}" loading="lazy">
             <span class="ml-1 text-xs capitalize Gilroy-medium">${TechnologyName}</span>
         </div>`;
        })
        .join("");

      technologyParent.innerHTML = techlist;

      techData.forEach((item) => {
        const techEle = document.getElementById(`item_${item?.id}`);

        if (techEle) {
          techEle.addEventListener("click", () => {
            const techListElements = document.getElementById(
              `list_${item?.id}`,
            );

            if (techEle.classList.contains("select_tech")) {
              const techListEle = document.getElementById(`tech_${item?.id}`);
              techEle.classList.remove("select_tech");
              techListElements?.classList.remove("select_tech");
              if (techListEle && selectTechnologyParent.contains(techListEle)) {
                selectTechnologyParent.removeChild(techListEle);
              }
              if (techListElements) {
                const img = techListElements.getElementsByTagName("img")[0];
                if (img) img.src = addIcon;
              }
            } else {
              technologyAdded(item);
              techEle.classList.add("select_tech");
              techListElements?.classList.add("select_tech");
              if (techListElements) {
                const img = techListElements.getElementsByTagName("img")[0];
                if (img) img.src = removeIcon;
              }
            }
          });
        }
      });
    })
    .catch((err) => {
      console.error("Error while fetching Technologies - > ", err);
    });
};

fetchedData();

/*This Code Through to APi Data Finish*/

function technologyAdded(addTechData) {
  let icon_close_tag = document.createElement("img");
  icon_close_tag.setAttribute(
    "src",
    "https://cdn.quokkalabs.com/ql-images/tech_cut_icon.png",
  );
  icon_close_tag.setAttribute("class", "ml-1");
  icon_close_tag.addEventListener("load", () => {
    let selectTechCover = document.createElement("div");
    selectTechCover.classList.add(
      "technology_btn",
      "inline-flex",
      "items-center",
      "border",
      "border-indigo-700",
      "cursor-pointer",
      "rounded",
      "p-3",
      "mr-2",
      "mb-2",
      "text-xs",
    );

    selectTechCover.setAttribute("id", `tech_${addTechData.id}`);
    const addTechData2 = document.getElementById(`list_${addTechData?.id}`);

    let addedtech = document.createTextNode(addTechData.name);
    selectTechCover.appendChild(addedtech);

    selectTechCover.appendChild(icon_close_tag);

    selectTechCover.addEventListener("click", function () {
      const techItemEle = document.getElementById(`item_${addTechData?.id}`);
      const techlistEle = document.getElementById(`list_${addTechData?.id}`);
      techItemEle?.classList.remove("select_tech");
      techlistEle?.classList.remove("select_tech");
      if (selectTechnologyParent.contains(selectTechCover)) {
        selectTechnologyParent.removeChild(selectTechCover);
      }
      if (addTechData2) {
        const img = addTechData2.getElementsByTagName("img")[0];
        if (img) img.src = addIcon;
      }
    });

    selectTechnologyParent.appendChild(selectTechCover);
  });
}

function myDebounce(callback, delay) {
  let timer;

  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback();
    }, delay);
  };
}

const debounce = myDebounce(() => {
  if (techSearchInput.value.trim()) {
    const childIds = [];
    if (selectTechnologyParent) {
      const childElements = selectTechnologyParent.children;

      for (let i = 0; i < childElements.length; i++) {
        const childId = childElements[i].id;
        if (childId) {
          childIds.push(childId);
        }
      }
    }
    console.log({ childIds });
    fetch(
      `${
        process.env.APIURL
      }/blog/api/technologies?search=${techSearchInput.value.trim()}`,
    )
      .then((response) => response.json())
      .then((parsedData) => {
        (Search_empty.classList.remove("flex"),
          Search_empty.classList.add("hidden"),
          toggleButton.classList.remove("pt-4"));

        const itemDivUl = document.createElement("ul");
        itemDivUl.classList.add("w-full", "bg-white", "mb-6");

        for (let i = 0; i < parsedData.data.length; i++) {
          let itemDiv = document.createElement("li");
          const existEle = childIds.find(
            (item) => item === `tech_${parsedData.data[i]?.id}`,
          );

          itemDiv.innerHTML = `
          <div class="flex items-center">
            <img src=${existEle ? removeIcon : addIcon}  loading="lazy"/>
            <span class="ml-1 text-xs capitalize Gilroy-medium">${
              parsedData.data[i]?.name
            }</span>
          </div>`;

          itemDiv.setAttribute("id", `list_${parsedData.data[i]?.id}`);
          itemDiv.classList.add(
            "px-4",
            "py-3",
            "w-full",
            "block",
            "cursor-pointer",
            "border",
            "border-b-gray-500",
            "search_list_hover",
          );
          if (existEle) {
            itemDiv.classList.add("select_tech");
          }
          itemDivUl.append(itemDiv);
        }
        techSuggestion.innerHTML = "";
        techSuggestion.appendChild(itemDivUl);

        for (const data of parsedData.data) {
          const techId = data.id;
          const element = document.getElementById(`list_${techId}`);

          if (element) {
            let changeIcon = element.querySelector("img");

            element.addEventListener("click", () => {
              if (element.classList.contains("select_tech")) {
                element.classList.remove("select_tech");
                const techEle = document.getElementById(`tech_${data?.id}`);
                const techItemEle = document.getElementById(`item_${data?.id}`);
                if (techEle && selectTechnologyParent.contains(techEle)) {
                  selectTechnologyParent.removeChild(techEle);
                }
                techItemEle?.classList.remove("select_tech");
                if (changeIcon) changeIcon.src = addIcon;
              } else {
                const techItemEle = document.getElementById(`item_${data?.id}`);
                techItemEle?.classList.add("select_tech");
                element.classList.add("select_tech");
                if (changeIcon) changeIcon.src = removeIcon;
                technologyAdded(data);
              }
            });
          }
        }
      })
      .catch((error) =>
        console.log(
          { error },
          Search_empty.classList.remove("hidden"),
          Search_empty.classList.add("flex"),
          toggleButton.classList.add("pt-4"),
        ),
      );
  } else {
    techSuggestion.innerHTML = "";
    (Search_empty.classList.remove("flex"),
      Search_empty.classList.add("hidden"),
      toggleButton.classList.remove("pt-4"));
  }
}, 500);
techSearchInput.addEventListener("keyup", debounce);

let clientName = document.getElementById("Client_Name");
let clientEmail = document.getElementById("Client_Email");
let clientCompany = document.getElementById("Company_Name");
let clientNumber = document.getElementById("Client_Mobile");
let clientDetail = document.getElementById("Additional_Detail");
let tags = document.getElementById("select_technologies");

const confirmPopup = document.getElementById("response_loading_popup");
let tagsArray = [];

function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

async function submitFormHire(event) {
  event.preventDefault();

  tagsArray = [];

  let isFormValid = true;

  const nameErrorElement = document.getElementById("nameError");
  const nameErrorField = document.getElementById("Client_Name");
  if (!clientName.value || clientName.value.trim() === "") {
    nameErrorElement.classList.remove("hidden");
    nameErrorElement.classList.add("flex");
    nameErrorField.classList.add("border-red-500");
    isFormValid = false;
  } else {
    nameErrorElement.classList.remove("flex");
    nameErrorElement.classList.add("hidden");
    nameErrorField.classList.remove("border-red-500");
  }

  const emailErrorElement = document.getElementById("emailError");
  const emailErrorField = document.getElementById("Client_Email");
  if (!clientEmail.value || clientEmail.value.trim() === "") {
    emailErrorElement.classList.remove("hidden");
    emailErrorElement.classList.add("flex");
    emailErrorField.classList.add("border-red-500");
    isFormValid = false;
  } else if (!isValidEmail(clientEmail.value.trim())) {
    alert("Invalid email address");
    emailErrorElement.classList.remove("hidden");
    emailErrorElement.classList.add("flex");
    emailErrorField.classList.add("border-red-500");
    isFormValid = false;
  } else {
    emailErrorElement.classList.remove("flex");
    emailErrorElement.classList.add("hidden");
    emailErrorField.classList.remove("border-red-500");
  }

  if (!isFormValid) {
    return;
  }

  const Mobile_Number = document.getElementById("Client_Mobile");
  const formD = new FormData();
  if (Mobile_Number.value.length < 9 && Mobile_Number.value.length > 0) {
    alert("Please add at least 9 digits phone number");
    return;
  } else if (Mobile_Number.value.length > 18) {
    alert("Please add maximum 18 digits phone number");
    return;
  } else {
    formD.append("number", Mobile_Number.value);
  }

  [...tags.children].forEach((e) => {
    const techName = e.innerText.replace(/\s+/g, " ").trim();
    if (techName) {
      tagsArray.push(techName);
    }
  });

  ErorDiv.classList.remove("block");
  ErorDiv.classList.add("hidden");
  technologyParent.classList.add("mt-3");

  formD.append("technology", JSON.stringify(tagsArray));
  formD.append("name", clientName.value);
  formD.append("email", clientEmail.value);
  formD.append("company_name", clientCompany.value ? clientCompany.value : "");
  formD.append("phone", clientNumber.value ? clientNumber.value : "");
  formD.append("description", clientDetail.value ? clientDetail.value : "");

  displayLoading();

  fetch(`${process.env.APIURL}/blog/api/hire-talents`, {
    method: "POST",
    body: formD,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("API call failed");
      }
      return response.json();
    })
    .then((data) => {
      hideLoading();
      if (data.status === true) {
        console.log({ data });

        // Save data before clearing fields
        localStorage.setItem("contact_name", clientName.value.trim());
        localStorage.setItem("contact_email", clientEmail.value.trim());

        clientName.value = "";
        clientEmail.value = "";
        clientCompany.value = "";
        clientNumber.value = "";
        clientDetail.value = "";
        tagsArray = [];

        // Redirect keep same
        window.location.href = "/thankyou";
      } else {
        console.log("error");
        alert(data.message || "Failed to submit form. Please try again.");
      }
    })
    .catch((err) => {
      hideLoading();
      console.error("Error while submitting form - > ", err);
      alert(
        "Failed to submit form. Please check your internet connection and try again.",
      );
    });
}

function closeConfirmPopup() {
  if (confirmPopup) {
    confirmPopup.style.display = "none";
  }
}

window.submitFormHire = submitFormHire;
window.closeConfirmPopup = closeConfirmPopup;

// THANK YOU PAGE DATA
document.addEventListener("DOMContentLoaded", () => {
  const userName = document.getElementById("userName");
  const userEmail = document.getElementById("userEmail");

  if (userName) {
    userName.textContent =
      localStorage.getItem("contact_name") || "No Name Found";
  }

  if (userEmail) {
    userEmail.textContent =
      localStorage.getItem("contact_email") || "No Email Found";
  }
});
